import styled from 'styled-components/macro'
import MuiCard from '@material-ui/core/Card'

const Card = styled(MuiCard)`
  margin-top: 24px;
`

export default Card
